module.exports = __webpack_public_path__ + "static/media/136.495179d5.png";